import angular from 'angular';
import bootstrap from 'angular-ui-bootstrap';

import i18n from '../i18n';
import uuid from '../uuid';

import dateRangeDirective from './date-range-directive';
import dateRangeService from './date-range-service';
import dateRangeDecorator from './date-range-decorator';
import datepickerPopupTemplate from './templates/popup.tpl.html';
import uibDatePickerDateRangeTemplate from './templates/uib-datepicker-daterange.tpl.html';
import dateRangeDayPopupTemplate from './templates/date-range-day-popup.tpl.html';

function run($templateCache) {
  /*
  Overide angular-ui bootstrap's datepicker popup template
  0.13.3 changed popup template to include ng-if which as a result broke binding in date-range
  Using popup template from 0.13.0 since it uses ng-show instead of ng-if
  */
  $templateCache.put('template/datepicker/popup.html', datepickerPopupTemplate);
  $templateCache.put('templates/uib-datepicker-daterange.tpl.html', uibDatePickerDateRangeTemplate);
  $templateCache.put('templates/date-range-day-popup.tpl.html', dateRangeDayPopupTemplate);
}
run.$inject = ['$templateCache'];

/**
 * @ngdoc module
 * @deprecated akamai.components.daterange
 * @name akamai.components.date-range
 *
 * @description The date-range component is a control that manages a range between a start and end
 * date. This is best used as a simple form control.
 *
 * @guideline https://design.akamai.com/components/date-range-input/
 *
 * @requires module:akamai.components.i18n
 * @requires module:akamai.components.uuid
 *
 * @example date-range.html
 * <akam-date-range
 *   ng-model="vm.dateRange"
 *   format="{% raw %}{{vm.format}}{% endraw %}"
 *   is-disabled="vm.disabled"
 *   is-readonly="vm.readOnly"
 *   min="vm.min"
 *   max="vm.max"
 *   on-select="cb(selectedDateRange, startDate, endDate)">
 * </akam-date-range>
 *
 */
export default angular.module('akamai.components.date-range', [
  bootstrap,
  i18n.name,
  uuid.name
])

.run(run)

.config(dateRangeDecorator)
/**
 * @name akamai.components.date-range.service:dateRangeService
 *
 * @description Provides util functions for date range manipulations for directive and decorator
 */
.factory('dateRangeService', dateRangeService)
/**
 * @ngdoc directive
 *
 * @name akamDateRange
 *
 * @description Creates a date range control that wraps two angular bootstrap date pickers.
 *
 * @param {{startDate: Date, endDate: Date}} ng-model The dateRange object.
 *
 * @param {string} [format='EEE, MMM dd, yyyy'] The format value.
 *
 * @param {boolean} [is-disabled=false] If disabled, no user interaction will be possible.
 *
 * @param {boolean} [is-readonly=false] If readonly, no user interaction will be possible but the
 * text will be easier to read.
 *
 * @param {string|TranslateKey} [placeholder='Select Dates'] The placeholder text for the search
 * input field.
 *
 * @param {string} [min] The min date is an ISO {ISO_VERSION} formatted date string
 * (e.g. 2015-8-1), it can dynamically change the min date calendar setting.
 *
 * @param {string} [max] The max date is an ISO {ISO_VERSION} formatted date string
 * (e.g. 2017-7-31), it can dynamically change max date calendar setting.
 *
 * @param {function(string, Date, Date)} [on-select] A function that is called when a date-range
 * is selected. The function signature will be
 * `someFunction(selectedDateRange, startDate, endDate)`.
 *
 */
.directive('akamDateRange', dateRangeDirective);